import { pluralize } from '@frontend/duck-tape';
import { Icon, LinkButton, Text, XStack, YStack } from '@frontend/web-react';

type ActivityToggleProps = {
  activityCount: number;
  isActive: boolean;
  onToggleActivity: () => void;
};

export const WhisperActivityToggle = ({ activityCount, isActive, onToggleActivity }: ActivityToggleProps) => (
  <YStack className="gap-xs items-start">
    {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
    <LinkButton className="ml-[-2px]" onClick={onToggleActivity}>
      <XStack className="gap-sm">
        <YStack>
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <Icon className="mb-[-4px]" color="tertiary" name="IconChevronUp" size={12} />
          <Icon color="tertiary" name="IconChevronDown" size={12} />
        </YStack>
        <Text color="tertiary" type="h5">
          {isActive ? 'Hide' : 'Show'} {activityCount} activity {pluralize('item', activityCount)}
        </Text>
      </XStack>
    </LinkButton>
    {/* eslint-disable-next-line tailwindcss/no-arbitrary-value,tailwindcss/no-custom-classname */}
    <YStack className="h-[24px] w-px border-neutral-300 border-l-1 ml-[4px] border-dashed" />
  </YStack>
);
